import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'
import AdminLayout from '../components/AdminLayout'

export default function AdminDashboard() {
  const { data: user, isLoading } = useQuery({
    queryKey: ['me'],
    queryFn: async () => (await api.get('/auth/me/')).data,
  })

  const { data: org } = useQuery({
    queryKey: ['organization'],
    queryFn: async () => (await api.get('/organization/')).data,
  })

  const { data: countries } = useQuery({
    queryKey: ['countries', 'count'],
    queryFn: async () => {
      const data = (await api.get('/countries/')).data
      return Array.isArray(data) ? { count: data.length } : data
    },
  })

  return (
    <AdminLayout>
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Dashboard</h2>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
        <StatCard
          label="Organization"
          value={org?.group_name || '—'}
          sub={org?.organization_type?.replace(/_/g, ' ') || ''}
        />
        <StatCard
          label="Countries configured"
          value={countries?.count?.toString() || '0'}
        />
        <StatCard label="Signed in as" value={user?.username || '—'} sub={user?.is_superuser ? 'Superuser' : 'Staff'} />
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="font-semibold text-gray-800 mb-3">Account</h3>
        {isLoading && <p className="text-gray-500 text-sm">Loading…</p>}
        {user && (
          <dl className="grid grid-cols-1 sm:grid-cols-2 gap-y-2 gap-x-6 text-sm">
            <Row k="User ID" v={user.id} />
            <Row k="Username" v={user.username} />
            <Row k="Email" v={user.email || '—'} />
            <Row k="Role" v={user.is_superuser ? 'Superuser' : user.is_staff ? 'Staff' : 'User'} />
            <Row k="Joined" v={user.date_joined ? new Date(user.date_joined).toLocaleString() : '—'} />
            <Row k="Last login" v={user.last_login ? new Date(user.last_login).toLocaleString() : '—'} />
          </dl>
        )}
      </div>
    </AdminLayout>
  )
}

function StatCard({ label, value, sub }: { label: string; value: string; sub?: string }) {
  return (
    <div className="bg-white rounded-lg shadow p-4">
      <p className="text-xs uppercase tracking-wide text-gray-500">{label}</p>
      <p className="text-xl font-semibold text-gray-900 mt-1">{value}</p>
      {sub && <p className="text-xs text-gray-500 mt-1">{sub}</p>}
    </div>
  )
}

function Row({ k, v }: { k: string; v: any }) {
  return (
    <div>
      <dt className="font-medium text-gray-500">{k}</dt>
      <dd className="text-gray-900">{v}</dd>
    </div>
  )
}
